<template>
  <Modal
    name="REPROVE_HOST_ONBOARDING"
    :title="`Reprovar ${host.name}`"
  >
    <template v-slot:body>
      <v-form v-model="valid">
        <div>
          <v-row no-gutters>
            <v-col cols="8">
              <v-select
                :items="disapproveTypes"
                :rules="rules.required"
                v-model="selectedType"
                outlined
                label="Motivo"
              >
                <template v-slot:item="{item}">
                  {{ $t(`hostOnboarding.disapproveTypes.${item}`) }}
                </template>
                <template v-slot:selection="{item}">
                  {{ $t(`hostOnboarding.disapproveTypes.${item}`) }}
                </template>
              </v-select>
            </v-col>
          </v-row>

          <v-row no-gutters class="mb-6">
            <v-col>
              <v-textarea v-model="description" label="Descrição" :rules="rules.required" outlined />
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col>
              <v-btn
                @click="closeModalAndReset"
                outlined
                color="error"
              >
                {{$t('hostOnboarding.actions.cancel')}}
              </v-btn>
            </v-col>
            <v-col class="d-flex justify-end">
              <v-btn
                @click="reproveHostOnboarding"
                :loading="isLoadingButton"
                color="error"
                :disabled="!valid"
              >
                {{$t('hostOnboarding.actions.confirm')}}
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-form>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/app/Modal'
import FilterSearch from '@/components/filters/FilterSearch'
import { mapGetters, mapActions } from 'vuex'
import { required } from '@/util/defaultValidationRules'

export default {
  name: 'ModalReproveHostOnboarding',

  props: {
    host: {
      type: Object,
    },
  },

  components: {
    Modal,
    FilterSearch,
  },
  
  watch: {
    allModals(val) {
      if(!val.includes('REPROVE_HOST_ONBOARDING')) {
        this.reset()
      }
    }
  },

  data() {
    return {
      rules: {
        required,
      },
      valid: false,
      selectedType: 'BACKGROUND_CHECK_SCORE',
      description: ''
    }
  },

  async mounted() {
    await this.fetchDisapproveTypes()
  },

  computed: {
    ...mapGetters(['isLoadingButton', 'disapproveTypes', 'allModals']),
  },

  methods: {
    ...mapActions(['closeModal', 'fetchDisapproveTypes', 'disapproveHostOnboarding']),

    closeModalAndReset() {
      this.reset()
      this.closeModal('REPROVE_HOST_ONBOARDING')
    },

    reset() {
      this.selectedType = 'BACKGROUND_CHECK_SCORE'
      this.description = ''
    },

    reproveHostOnboarding() {
      let request = {
        host_id: this.host.id,
        disapprove_type: this.selectedType,
        disapprove_description: this.description
      }
      this.disapproveHostOnboarding(request)
    },
  },
}
</script>
